import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MicroserviceTokenResponse } from '../interfaces/token.interface';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppConfiguration } from 'src/app/app.configuration';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache'
  })
};

@Injectable({
  providedIn: 'root'
})
export class MicroserviceService {
  private urlApi = '';

  constructor(private config: AppConfiguration, private http: HttpClient) {
    this.urlApi = this.config.getConfig('API_URL_MS');
  }

  getTokenMicroservice(username: string, password: string): Observable<MicroserviceTokenResponse> {
    const body = {
      username,
      password
    };

    const URL = `${this.urlApi}Token`;

    const response = this.http.post<MicroserviceTokenResponse>(URL, body, {
      headers: {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache'
      }
    });

    return response;
  }

  refreshToken(data: MicroserviceTokenResponse) {
    const body = {
      token: data.token,
      refreshToken: data.refreshToken
    };

    const URL = `${this.urlApi}Refresh`;

    const response = this.http.post<MicroserviceTokenResponse>(URL, body, httpOptions);

    return response;
  }

  loginMicroservice(data: MicroserviceTokenResponse) {
    sessionStorage.setItem('tokenMicroservice', data.token);
    sessionStorage.setItem('microserviceData', JSON.stringify(data));
  }
}
